import unixToISO from 'common/utils/Dates/unixToISO';
import dollarsToCents from 'common/utils/Money/dollarsToCents';
import moment from 'moment';
import { DATE_TYPE_VALUES } from '../../../utils/serviceAuthorizationUtils';

/**
 * Builds the shared portion of the submit payload for both authorization modals.
 *
 * @param {object} formData - react-final-form values
 * @param {object} options
 * @param {boolean} options.isUnitBased
 * @param {'approved' | 'requested'} options.prefix - determines the key names in the payload
 */
export function buildSubmitPayload(formData, { isUnitBased, prefix }) {
  const {
    authorized_amount,
    date_type,
    single_date,
    range_date_start,
    range_date_end,
    clinical_modification_code,
  } = formData;

  const amountKey = isUnitBased ? `${prefix}_unit_amount` : `${prefix}_cents`;
  const amountValue = isUnitBased ? parseInt(authorized_amount, 10) : dollarsToCents(authorized_amount);
  const normalizedSingleDate = moment.unix(single_date).utc().startOf('day').unix();

  const startsAt = unixToISO(
    date_type === DATE_TYPE_VALUES.SINGLE_DATE ? normalizedSingleDate : range_date_start,
  );
  const endsAt = unixToISO(
    date_type === DATE_TYPE_VALUES.SINGLE_DATE ? normalizedSingleDate : range_date_end,
  );

  return {
    [amountKey]: amountValue,
    [`${prefix}_starts_at`]: startsAt,
    [`${prefix}_ends_at`]: endsAt,
    clinical_modifications: [{
      id: clinical_modification_code?.id,
      type: 'clinical_modification',
    }],
  };
}
